import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

  type Alert = "success" | "danger";

  interface Props {
    message: string;
    type: Alert;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AlertComponent',
  props: {
    message: {},
    type: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const getAlertClasses = computed(() => {
    return `alert--${props.type}`;
  });

const __returned__ = { props, getAlertClasses, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})